module.exports = __webpack_public_path__ + "media/error.80eeca90.svg";